export const PurchaseInvoiceUrl = '/purchase-invoices'
export const PackingSlipDetailUrl = '/purchase-invoices/:invoiceNumber/packing-slip/:packingSlipNumber'
export const PackingSlipPdfViewUrl = '/purchase-invoices/:invoiceNumber/packing-slip/:packingSlipNumber/view'
export const InvoicePdfViewUrl = '/purchase-invoices/:invoiceNumber/packing-slip/:packingSlipNumber/invoice'

export const getPackingSlipDetailUrl = (invoiceNumber: string, packingSlipNumber: string): string => {
  return `/purchase-invoices/${invoiceNumber}/packing-slip/${packingSlipNumber}`
}

export const getPackingSlipPdfViewUrl = (invoiceNumber: string, packingSlipNumber: string): string => {
  return `/purchase-invoices/${invoiceNumber}/packing-slip/${packingSlipNumber}/view`
}

export const getInvoicePdfViewUrl = (invoiceNumber: string, packingSlipNumber: string): string => {
  return `/purchase-invoices/${invoiceNumber}/packing-slip/${packingSlipNumber}/invoice`
}
